import { useState, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
// import '../index.css'; // Keep if general page styling is needed
import "../../DocViewer/components/Modal.css"; // Keep if modal styling is needed
import { Document, Page, pdfjs } from "react-pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import './Flipbook.css'; // Import a CSS file for styling

// Set the workerSrc for pdfjs
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// Define desired dimensions for a SINGLE page
const PAGE_WIDTH = 400; // Adjust as needed
const PAGE_HEIGHT = 550; // Adjust as needed

function Flipbook({ filePath }) {
  const [numPages, setNumPages] = useState(null);
  const flipBookRef = useRef(null);
  const [currentPageNum, setCurrentPageNum] = useState(1); // Track current page

  // Callback function when the PDF is loaded successfully
  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  // Callback for page flips to update current page number
  const handleFlip = (e) => {
    // The 'data' property holds the current page number (zero-based index of the left page)
    // For a two-page view, the actual page number shown on the right is data + 1 or data + 2
    // Let's simplify and track the logical 'current spread' based on the event data.
    // Note: react-pageflip's page numbering can be complex depending on cover settings.
    // A common approach is to think of the 'current view index' it provides.
    setCurrentPageNum(e.data + 1); // Adjust based on how you want to display page numbers
  };

  // Function to generate the list of Page components
  const renderPages = () => {
    const pages = [];
    if (!numPages) {
      return pages;
    }
    for (let i = 1; i <= numPages; i++) {
      pages.push(
        // Each page needs a wrapper div for react-pageflip
        // Add a class to style the page content container if needed
        <div key={`page_${i}`} className="flipbook-page-container">
          <Page
            // Set dimensions for EACH page render
            width={PAGE_WIDTH}
            height={PAGE_HEIGHT}
            pageNumber={i}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            renderInteractiveForms={false}
            className="flipbook-react-pdf-page" // Add class for specific react-pdf page styling
          />
          {/* Optional: Display page number centered at the bottom */}
          <div className="flipbook-page-number">{i}</div>
        </div>
      );
    }
    return pages;
  };

  // Calculate the total width for the flipbook component (two pages side-by-side)
  const flipbookTotalWidth = PAGE_WIDTH * 2;

  return (
    <div className="flipbook-viewer-container">
      {/* Document component to load the PDF */}
      <Document
        file={filePath}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div className="loading-message">Loading PDF...</div>}
        error={<div className="error-message">Failed to load PDF. Please try again.</div>}
        // Removed className="modal-90w" unless specifically needed for Document wrapper
      >
        {/* Conditionally render FlipBook only when numPages is known */}
        {numPages && (
          <div className="flipbook-wrapper"> {/* Added wrapper for centering/styling */}
            <HTMLFlipBook
              // Set the total width and height for the TWO-PAGE view
              width={PAGE_WIDTH} // Width of a SINGLE page side
              height={PAGE_HEIGHT}
              size="stretch" // Allows pages to stretch to fit container
              minWidth={PAGE_WIDTH} // Min width for a page
              maxWidth={PAGE_WIDTH} // Max width for a page
              minHeight={PAGE_HEIGHT} // Min height for a page
              maxHeight={PAGE_HEIGHT} // Max height for a page
              // drawShadow={true} // Optional: adds shadow effect between pages
              flippingTime={1000} // Optional: animation speed
              usePortrait={false} // Crucial: Ensures landscape-like two-page view
              startZIndex={0}
              maxShadowOpacity={0.5} // Optional: shadow intensity
              showCover={false} // Set true if you want page 1 as a single cover page initially
              mobileScrollSupport={true} // Better mobile experience
              onFlip={handleFlip} // Get notified on page turns
              ref={flipBookRef}
              className="actual-flipbook-component" // Class for the core flipbook
            >
              {renderPages()}
            </HTMLFlipBook>
          </div>
        )}
      </Document>

      {/* Optional: External Controls (Example) */}
      {numPages && flipBookRef.current && (
        <div className="flipbook-controls">
          <button
             onClick={() => flipBookRef.current?.pageFlip()?.flipPrev()}
             disabled={currentPageNum <= 1} // Disable if on the first page/spread
          >
            Previous
          </button>
          <span>
            {/* Adjust page number display logic based on cover settings and preference */}
            Page {currentPageNum} - {currentPageNum + 1 > numPages ? '' : currentPageNum + 1} of {numPages}
          </span>
          <button
             onClick={() => flipBookRef.current?.pageFlip()?.flipNext()}
             disabled={currentPageNum >= numPages -1} // Disable if on the last page/spread
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default Flipbook;